import React from 'react'
import { Backdrop, CircularProgress, Stack, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

const GlobalLoader = ({ forceOpen = false }) => {
  const { loaderVisible, loaderMessage } = useSelector((state) => state.loader)

  // El forceOpen se añadió para poder usarlo desde el Suspense que envuelve las rutas de la aplica, y dejar de usar el LoadingPage
  const open = forceOpen || loaderVisible

  return (
    <Backdrop
      open={open}
      sx={{
        color: (theme) => theme.palette.neutrals.n00.color,
        // Hay que revisar los zIndex de la aplica y ponerlos todos en relación a algun parametro del theme, o crear cosas en el theme para ello
        zIndex: (theme) => 2001,
        backdropFilter: 'blur(2px)',
      }}>
      <Stack spacing={2} alignItems="center">
        <CircularProgress size={'10rem'} />
        {loaderMessage ? (
          <Typography variant="body_xxs_medium" sx={{ opacity: 0.9 }}>
            {loaderMessage}
          </Typography>
        ) : null}
      </Stack>
    </Backdrop>
  )
}

export default GlobalLoader
